import React from 'react';

import SearchResults from './SearchResults/SearchResults';
import useGetEntitiesForUser from './hooks/useGetEntitiesForUser';

const UserEntityList = () => {
  const { brands, draftVenues, enterprises, isLoading, merchants, venues } = useGetEntitiesForUser();

  return (
    <SearchResults
      draftVenues={draftVenues}
      enterprises={enterprises}
      isLoading={isLoading}
      merchants={merchants}
      venues={venues}
      brands={brands}
    />
  );
};

export default UserEntityList;
